import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CategoryCard = ({ category }) => {
  return (
    <Link 
      to={`/category/${category.id}`}
      className="group"
      data-testid={`category-card-${category.id}`}
    >
      <div className="aspect-square rounded-3xl relative overflow-hidden cursor-pointer">
        {/* Background Image */}
        <img
          src={category.image}
          alt={category.name}
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
        
        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
          <h3 
            className="text-white text-lg md:text-xl font-bold mb-1"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            {category.name}
          </h3>
          <div className="flex items-center gap-2 text-white/80 group-hover:text-white transition-colors">
            <span className="text-sm" style={{ fontFamily: 'Quicksand, sans-serif' }}>
              {category.productCount} Products
            </span>
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
